module.exports = __webpack_public_path__ + "c952c8a27263d292df088048a3bf68e9.png";